import type { AppState } from '../core/types';

export interface CasurHydricLayerVisibility {
  readonly channels: boolean;
  readonly drainage: boolean;
}

export const casurHydricLayerVisibility = (
  state: Pick<AppState, 'casurHydricReference' | 'casurHydricVisibility'>,
): CasurHydricLayerVisibility => ({
  channels: Boolean(state.casurHydricReference) && state.casurHydricVisibility.channels,
  drainage: Boolean(state.casurHydricReference) && state.casurHydricVisibility.drainage,
});
